import { FC } from 'react'
import styles from './styles.module.scss'
import cx from 'classnames'
import { CmsResponsiveImage } from '../ComposedPage/types'
import { DynamicImage } from '../DynamicImage'

export enum AuthorImageSize {
  LARGE = 'large',
  SMALL = 'small',
  MEDIUM = 'medium',
}

export interface AuthorImageProps {
  photo: CmsResponsiveImage
  name: string
  className?: string
  size?: AuthorImageSize
}

export const AuthorImage: FC<AuthorImageProps> = ({
  photo,
  name,
  className,
  size = AuthorImageSize.SMALL,
}) => {
  return (
    <DynamicImage
      className={cx(className, styles.authorImage, {
        [styles.small]: size === AuthorImageSize.SMALL,
        [styles.medium]: size === AuthorImageSize.MEDIUM,
        [styles.large]: size === AuthorImageSize.LARGE,
      })}
      image={photo}
      itemProp="image"
      sizes="(max-width: 600px) 50vw, 600px"
      alt={name}
      width={photo.fields.file.details.image.width}
      height={photo.fields.file.details.image.height}
    />
  )
}
